import axios from 'axios';
import {Message} from 'element-ui';

//上传文件
export function uploadimg(event) { // 传参是$event
    let formData = new FormData();
    formData.append('targetFile', event.file);
    return axios({
        method: 'POST',
        url: 'mch/common/uploadFile',
        headers: {
            'Content-Type': 'multipart/form-data',
            'access-token': sessionStorage.getItem("token")
        },
        data: formData
    }).then((res) => {
        // this.dataForm.avatar = res.data.file_name;
        let result = res.data.file_name;
        return Promise.resolve(result)
    })
}

// 格式化时间戳
export function formatDate(timestamp) {
    if (timestamp) {
        var date = new Date(timestamp * 1000);
        var Y = date.getFullYear() + '';
        var M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
        var D = add0(date.getDate());
        var h = add0(date.getHours());
        var m = add0(date.getMinutes());
        var s = add0(date.getSeconds());
        return Y + "-" + M + "-" + D + " " + h + ":" + m + ":" + s;
    }

}

function add0(m) {
    return m < 10 ? '0' + m : m
}

//判断是否为数字
export function isRealNum(val) {
    // isNaN()函数 把空串 空格 以及NUll 按照0来处理 所以先去除，

    if (val === "" || val == null) {
        return false;
    }
    if (!isNaN(val)) {
        //对于空数组和只有一个数值成员的数组或全是数字组成的字符串，isNaN返回false，例如：'123'、[]、[2]、['123'],isNaN返回false,
        //所以如果不需要val包含这些特殊情况，则这个判断改写为if(!isNaN(val) && typeof val === 'number' )
        return true;
    } else {
        return false;
    }
}
